import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const postGet = (url, config = {}) => axios.post(url, {}, config);
const postDelete = (url, config = {}) => axios.post(url, {}, config);

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Tracks
export const fetchTracks = async (params = {}) => {
  const response = await postGet(`${API_URL}/tracks`, { params });
  return response.data;
};

export const fetchTrack = async (id) => {
  const response = await postGet(`${API_URL}/tracks/${id}`);
  return response.data;
};

export const likeTrack = async (id) => {
  const response = await axios.post(`${API_URL}/tracks/${id}/like`, {}, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const fetchLikedTracks = async () => {
  const response = await postGet(`${API_URL}/tracks/user/liked`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

// Categories
export const fetchCategories = async () => {
  const response = await postGet(`${API_URL}/categories`);
  return response.data;
};

export const fetchMoodCategories = async () => {
  const response = await postGet(`${API_URL}/mood-categories`);
  return response.data;
};

export const fetchSectionTracks = async (sectionId) => {
  const response = await postGet(`${API_URL}/sections/${sectionId}/tracks`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const fetchTopTracksByStreams = async (limit = 50) => {
  const response = await postGet(`${API_URL}/tracks/top/by-streams`, {
    params: { limit }
  });
  return response.data;
};

export const fetchCategory = async (id) => {
  const response = await postGet(`${API_URL}/categories/${id}`);
  return response.data;
};

// Playlists
export const fetchPlaylists = async () => {
  const response = await postGet(`${API_URL}/playlists`);
  return response.data;
};

export const fetchPlaylist = async (id) => {
  const response = await postGet(`${API_URL}/playlists/${id}`);
  return response.data;
};

export const fetchUserPlaylists = async () => {
  const response = await postGet(`${API_URL}/playlists/user/playlists`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const createPlaylist = async (data) => {
  const response = await axios.post(`${API_URL}/playlists/create`, data, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const addTrackToPlaylist = async (playlistId, trackId) => {
  const response = await axios.post(
    `${API_URL}/playlists/${playlistId}/tracks/add`,
    { track_id: trackId },
    { headers: getAuthHeaders() }
  );
  return response.data;
};

export const removeTrackFromPlaylist = async (playlistId, trackId) => {
  // Utilise POST au lieu de DELETE pour compatibilité OVH mutualisé
  const response = await axios.post(
    `${API_URL}/playlists/${playlistId}/tracks/${trackId}/remove`,
    {},
    { headers: getAuthHeaders() }
  );
  return response.data;
};

// Artists
export const fetchArtists = async () => {
  const response = await postGet(`${API_URL}/artists`);
  return response.data;
};

export const fetchArtist = async (id) => {
  const response = await postGet(`${API_URL}/artists/${id}`);
  return response.data;
};

// Admin
// DEPRECATED: Ancienne méthode avec multipart - ne fonctionne pas sur OVH mutualisé
export const uploadTrack = async (formData, onProgress = null) => {
  const response = await axios.post(`${API_URL}/admin/tracks`, formData, {
    headers: {
      ...getAuthHeaders(),
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: (progressEvent) => {
      if (onProgress && progressEvent.total) {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        onProgress(percentCompleted);
      }
    }
  });
  return response.data;
};

// NOUVELLE MÉTHODE: Upload direct vers Bunny CDN puis envoi des métadonnées au backend
export const createTrackWithUrls = async (trackData) => {
  console.log('📤 createTrackWithUrls called with:', trackData);
  console.log('📤 API_URL:', API_URL);
  console.log('📤 Headers:', getAuthHeaders());
  
  try {
    const response = await axios.post(`${API_URL}/admin/tracks/create`, trackData, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'application/json'
      }
    });
    console.log('✅ createTrackWithUrls success:', response.data);
    return response.data;
  } catch (error) {
    console.error('❌ createTrackWithUrls error:', error);
    console.error('❌ Response:', error.response?.data);
    console.error('❌ Status:', error.response?.status);
    throw error;
  }
};

export const updateTrack = async (id, data) => {
  const response = await axios.post(`${API_URL}/admin/tracks/${id}/update`, data, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const deleteTrack = async (id) => {
  // Utilise POST au lieu de DELETE pour compatibilité OVH mutualisé
  const response = await axios.post(`${API_URL}/admin/tracks/${id}/delete`, {}, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const createCategory = async (data) => {
  const response = await axios.post(`${API_URL}/admin/categories`, data, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const updateCategory = async (id, data) => {
  // Utilise POST au lieu de PUT pour compatibilité OVH mutualisé
  const response = await axios.post(`${API_URL}/admin/categories/${id}/update`, data, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const deleteCategory = async (id) => {
  // Utilise POST au lieu de DELETE pour compatibilité OVH mutualisé
  const response = await axios.post(`${API_URL}/admin/categories/${id}/delete`, {}, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const fetchAdminStats = async (params = {}) => {
  const response = await postGet(`${API_URL}/admin/stats`, {
    headers: getAuthHeaders(),
    params: { ...params, _ts: Date.now() }
  });
  return response.data;
};

export const fetchAdminUsers = async () => {
  const response = await postGet(`${API_URL}/admin/users`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const createArtist = async (formData) => {
  const response = await axios.post(`${API_URL}/admin/artists`, formData, {
    headers: {
      ...getAuthHeaders(),
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

// NOUVELLE MÉTHODE: Créer un artiste avec URLs Bunny CDN pré-uploadées
export const createArtistWithUrls = async (artistData) => {
  console.log('📤 createArtistWithUrls called with:', artistData);
  try {
    const response = await axios.post(`${API_URL}/admin/artists/create`, artistData, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'application/json'
      }
    });
    console.log('✅ createArtistWithUrls success:', response.data);
    return response.data;
  } catch (error) {
    console.error('❌ createArtistWithUrls error:', error);
    console.error('❌ Response:', error.response?.data);
    throw error;
  }
};

export const updateArtist = async (id, formData) => {
  // Utilise POST au lieu de PUT pour compatibilité OVH mutualisé
  const response = await axios.post(`${API_URL}/admin/artists/${id}/update`, formData, {
    headers: {
      ...getAuthHeaders(),
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

// NOUVELLE MÉTHODE: Mettre à jour un artiste avec URLs Bunny CDN pré-uploadées
export const updateArtistWithUrls = async (id, artistData) => {
  console.log('📤 updateArtistWithUrls called with:', id, artistData);
  try {
    // Utilise POST au lieu de PUT pour compatibilité OVH mutualisé
    const response = await axios.post(`${API_URL}/admin/artists/${id}/update`, artistData, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'application/json'
      }
    });
    console.log('✅ updateArtistWithUrls success:', response.data);
    return response.data;
  } catch (error) {
    console.error('❌ updateArtistWithUrls error:', error);
    console.error('❌ Response:', error.response?.data);
    throw error;
  }
};

export const deleteArtist = async (id) => {
  // Utilise POST au lieu de DELETE pour compatibilité OVH mutualisé
  const response = await axios.post(`${API_URL}/admin/artists/${id}/delete`, {}, {
    headers: getAuthHeaders()
  });
  return response.data;
};


// Playlists et dossiers - Nouvelles fonctions
export const fetchUserLibrary = async () => {
  const response = await postGet(`${API_URL}/playlists/user/library`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const createFolder = async (data) => {
  const response = await axios.post(`${API_URL}/playlists/folders/create`, data, {
    headers: getAuthHeaders()
  });
  return response.data;
};



// Personalized content
export const recordPlay = async (trackId, sourceType = 'track', sourceId = null) => {
  const response = await axios.post(`${API_URL}/personalized/play-history`, 
    { track_id: trackId, source_type: sourceType, source_id: sourceId },
    { headers: getAuthHeaders() }
  );
  return response.data;
};

export const fetchHomeHistory = async (limit = 8) => {
  const response = await postGet(`${API_URL}/personalized/home-history`, {
    headers: getAuthHeaders(),
    params: { limit }
  });
  return response.data;
};

export const fetchRecentlyPlayed = async (limit = 10) => {
  const response = await postGet(`${API_URL}/personalized/recently-played`, {
    headers: getAuthHeaders(),
    params: { limit }
  });
  return response.data;
};

export const likeTrackPersonalized = async (trackId) => {
  const response = await axios.post(`${API_URL}/personalized/like/${trackId}`, {}, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const unlikeTrack = async (trackId) => {
  // Utilise POST au lieu de DELETE pour compatibilité OVH mutualisé
  const response = await axios.post(`${API_URL}/personalized/unlike/${trackId}`, {}, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const fetchLikedTracksPersonalized = async () => {
  const response = await postGet(`${API_URL}/personalized/liked-tracks`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const checkIsLiked = async (trackId) => {
  const response = await postGet(`${API_URL}/personalized/is-liked/${trackId}`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const fetchRecommendations = async (limit = 10) => {
  const response = await postGet(`${API_URL}/personalized/recommendations`, {
    headers: getAuthHeaders(),
    params: { limit }
  });
  return response.data;
};

// Admin Playlists
export const fetchAdminPlaylists = async () => {
  const response = await postGet(`${API_URL}/playlists/admin/all`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const createAdminPlaylist = async (formData) => {
  const response = await axios.post(`${API_URL}/playlists/admin/create`, formData, {
    headers: {
      ...getAuthHeaders(),
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

export const updateAdminPlaylist = async (id, data) => {
  // Utilise POST au lieu de PUT pour compatibilité OVH mutualisé
  const response = await axios.post(`${API_URL}/playlists/admin/${id}/update`, data, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const updateAdminPlaylistImage = async (id, formData) => {
  // Utilise POST pour compatibilité OVH mutualisé
  const response = await axios.post(`${API_URL}/playlists/admin/${id}/image`, formData, {
    headers: {
      ...getAuthHeaders(),
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

export const deleteAdminPlaylist = async (id) => {
  // Utilise POST au lieu de DELETE pour compatibilité OVH mutualisé
  const response = await axios.post(`${API_URL}/playlists/admin/${id}/delete`, {}, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const generateRandomPlaylist = async (playlistId, categoryId, count = 10) => {
  const response = await axios.post(
    `${API_URL}/playlists/admin/${playlistId}/generate-random`,
    { category_id: categoryId, count },
    { headers: getAuthHeaders() }
  );
  return response.data;
};


// ============== API PUBLICITÉS ==============

// Générer un session ID unique pour les utilisateurs non connectés
export const getAdSessionId = () => {
  let sessionId = localStorage.getItem('ad_session_id');
  if (!sessionId) {
    sessionId = 'sess_' + Math.random().toString(36).substr(2, 9) + Date.now().toString(36);
    localStorage.setItem('ad_session_id', sessionId);
  }
  return sessionId;
};

const toAdRouteParam = (value) => {
  if (value === undefined || value === null || value === '') {
    return 'all';
  }
  return encodeURIComponent(String(value));
};

// Récupérer une publicité visuelle
export const fetchVisualAd = async (position, country, language) => {
  const sessionId = getAdSessionId();
  const positionParam = toAdRouteParam(position);
  const countryParam = toAdRouteParam(country);
  const languageParam = toAdRouteParam(language);
  const sessionParam = toAdRouteParam(sessionId);
  const response = await postGet(
    `${API_URL}/ads/serve/visual/${positionParam}/${countryParam}/${languageParam}/${sessionParam}`,
    { headers: getAuthHeaders() }
  );
  return response.data;
};

// Récupérer une publicité audio
export const fetchAudioAd = async (country, language) => {
  const sessionId = getAdSessionId();
  const countryParam = toAdRouteParam(country);
  const languageParam = toAdRouteParam(language);
  const sessionParam = toAdRouteParam(sessionId);
  const response = await postGet(
    `${API_URL}/ads/serve/audio/${countryParam}/${languageParam}/${sessionParam}`,
    { headers: getAuthHeaders() }
  );
  return response.data;
};

// Incrémenter le compteur de pistes jouées
export const trackAdPlayed = async () => {
  const sessionId = getAdSessionId();
  const sessionParam = toAdRouteParam(sessionId);
  const response = await axios.post(
    `${API_URL}/ads/track-played/${sessionParam}`,
    { session_id: sessionId },
    { headers: getAuthHeaders() }
  );
  return response.data;
};

// Enregistrer un clic sur une pub
export const recordAdClick = async (adId) => {
  const sessionId = getAdSessionId();
  const response = await axios.post(`${API_URL}/ads/click/${adId}`, 
    { session_id: sessionId },
    { headers: getAuthHeaders() }
  );
  return response.data;
};

// Marquer une pub audio comme terminée
export const recordAdComplete = async (adId) => {
  const sessionId = getAdSessionId();
  const response = await axios.post(`${API_URL}/ads/complete/${adId}`, 
    { session_id: sessionId },
    { headers: getAuthHeaders() }
  );
  return response.data;
};

// ============== API ADMIN PUBLICITÉS ==============

export const fetchAllAds = async () => {
  const response = await postGet(`${API_URL}/ads/admin/list`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const createAd = async (adData) => {
  const response = await axios.post(`${API_URL}/ads/admin/create`, adData, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const updateAd = async (id, adData) => {
  // Utilise POST au lieu de PUT pour compatibilité OVH mutualisé
  const response = await axios.post(`${API_URL}/ads/admin/${id}/update`, adData, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const deleteAd = async (id) => {
  // Utilise POST au lieu de DELETE pour compatibilité OVH mutualisé
  const response = await axios.post(`${API_URL}/ads/admin/${id}/delete`, {}, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const toggleAd = async (id) => {
  // Utilise POST au lieu de PATCH pour compatibilité OVH mutualisé
  const response = await axios.post(`${API_URL}/ads/admin/${id}/toggle`, {}, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const fetchAdStats = async () => {
  const response = await postGet(`${API_URL}/ads/admin/stats`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

// Stories
export const fetchStories = async () => {
  const response = await postGet(`${API_URL}/stories`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const fetchStoryStatus = async () => {
  const response = await postGet(`${API_URL}/stories/status`);
  return response.data;
};

export const updateStoryStatus = async (enabled) => {
  const response = await axios.post(`${API_URL}/stories/admin/status`, { enabled }, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const publishStory = async (formData) => {
  const response = await axios.post(`${API_URL}/stories`, formData, {
    headers: {
      ...getAuthHeaders(),
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

export const toggleStoryLike = async (storyId) => {
  const response = await axios.post(`${API_URL}/stories/${storyId}/like`, {}, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const fetchStoryComments = async (storyId) => {
  const response = await postGet(`${API_URL}/stories/${storyId}/comments/list`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const addStoryComment = async (storyId, content, parentId = null) => {
  const response = await axios.post(`${API_URL}/stories/${storyId}/comments`, {
    content,
    parent_id: parentId
  }, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const toggleStoryCommentLike = async (commentId) => {
  const response = await axios.post(`${API_URL}/stories/comments/${commentId}/like`, {}, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const reportStory = async (storyId, reason) => {
  const response = await axios.post(`${API_URL}/stories/${storyId}/report`, { reason }, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const deleteStory = async (storyId) => {
  const response = await postDelete(`${API_URL}/stories/${storyId}`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const fetchAdminStories = async () => {
  const response = await postGet(`${API_URL}/stories/admin`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const fetchStoryReports = async (storyId) => {
  const response = await postGet(`${API_URL}/stories/admin/${storyId}/reports`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const blockStory = async (storyId) => {
  const response = await axios.post(`${API_URL}/stories/admin/${storyId}/block`, {}, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const unblockStory = async (storyId) => {
  const response = await axios.post(`${API_URL}/stories/admin/${storyId}/unblock`, {}, {
    headers: getAuthHeaders()
  });
  return response.data;
};

 
